export default function MemeAlertsIcon({ color, className }:{ color?: string; className?: string }) {
  return (
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="14.000000pt"
        height="14.000000pt"
        className={className}
        viewBox="-20 -10 110 110"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,96.000000) scale(0.040000,-0.040000)"
          fill={color || "#000000"}
          stroke="none"
        >
          {" "}
          <path d="M400 2362 c0 -21 -10 -57 -23 -81 -47 -90 -177 -700 -177 -827 0 -33 -16 -134 -36 -225 -70 -330 -114 -593 -114 -684 0 -51 -11 -99 -25 -107 -126 -78 181 -388 383 -388 115 0 144 72 166 415 10 153 26 290 36 306 9 15 18 141 18 278 2 496 110 504 174 14 54 -421 83 -461 313 -429 176 24 193 43 383 428 139 282 190 363 228 363 54 0 68 -91 25 -169 -53 -97 -98 -230 -151 -443 -30 -124 -72 -277 -93 -340 -36 -105 -35 -120 4 -180 85 -130 324 -258 457 -246 55 5 91 113 109 328 17 206 38 359 111 800 166 1004 166 1003 -95 1112 -51 21 -93 55 -93 76 0 23 -24 37 -65 37 -94 0 -180 -115 -384 -512 -56 -111 -113 -217 -125 -238 -13 -21 -65 -124 -116 -231 -55 -115 -111 -199 -140 -208 -64 -20 -61 -26 -95 189 -58 375 -70 439 -96 500 -14 34 -32 92 -39 127 -18 85 -118 183 -255 249 -60 29 -110 69 -110 89 0 23 -29 35 -87 35 -62 0 -88 -11 -88 -38z" />{" "}
          <path d="M891 480 c-33 -53 209 -78 284 -30 29 18 19 24 -41 25 -43 0 -112 7 -153 15 -41 8 -82 4 -90 -10z" />{" "}
        </g>
      </svg>
  );
}
